module.exports = __webpack_public_path__ + "static/media/x.e2cf8c2d.svg";